<template>
  <div v-if="filteredAlerts.length > 0" class="alerts-wrapper">
    <div 
      class="alert-banner"
      :class="getAlertClass(currentAlert.type)"
    >
      <div class="alert-content-wrapper">
        
        <div class="alert-icon">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor">
            <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
          </svg>
        </div>

        <div class="alert-text">
          <span class="alert-title" v-html="currentAlert.title"></span>
          <span class="alert-subtitle" v-html="currentAlert.subtitle"></span>

          <a 
            v-if="currentAlert.link" 
            :href="currentAlert.link" 
            target="_blank" 
            class="alert-link"
          >
            {{ $t('alert.more-details') }}
          </a>
        </div>

        <div class="alert-navigation" v-if="filteredAlerts.length > 1">
          <button @click="prevAlert" class="nav-btn" :disabled="currentIndex === 0">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
              <path d="M11 1l-7 7 7 7" stroke="currentColor" stroke-width="2" fill="none"/>
            </svg>
          </button>
          <span class="alert-counter">{{ currentIndex + 1 }} of {{ filteredAlerts.length }}</span>
          <button @click="nextAlert" class="nav-btn" :disabled="currentIndex === filteredAlerts.length - 1">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
              <path d="M5 1l7 7-7 7" stroke="currentColor" stroke-width="2" fill="none"/>
            </svg>
          </button>
        </div>
        <button @click="dismissCurrentAlert" class="alert-close">&times;</button>
    </div>
  </div>
  </div>
</template>

<script>
export default {
  name: 'AlertBanner',

  data() {
    return {
      alerts: [],
      currentIndex: 0
    }
  },

  computed: {
    currentAlert() {
      return this.filteredAlerts[this.currentIndex] || {}
    },

    isProfilePage() {
      return this.$route.meta?.hasSidebar === true
    },

    filteredAlerts() {
      return this.alerts.filter(alert => {
        const showIn = alert.show_in || 'all'

        if (showIn === 'all') return true
        if (showIn === 'profile') return this.isProfilePage
        if (showIn === 'public') return !this.isProfilePage

        return true
      })
    }
  },

  mounted() {
    this.fetchAlerts()
  },

  watch: {
    '$route': {
      immediate: true,
      handler() {
        this.currentIndex = 0
      }
    }
  },

  methods: {
    async fetchAlerts() {
      try {
        const response = await this.$http.get(`${window.API_ROOT}/api/alerts`)

        if (response.body?.status === 'success') {
          this.alerts = response.body.data || []
        }

      } catch (e) {
        console.error('alerts error', e)
      }
    },

    getAlertClass(type) {
      return {
        warning: 'alert-warning',
        primary: 'alert-primary',
        danger: 'alert-danger',
        info: 'alert-info'
      }[type] || 'alert-info'
    },

    nextAlert() {
      if (this.currentIndex < this.filteredAlerts.length - 1) {
        this.currentIndex++
      }
    },

    prevAlert() {
      if (this.currentIndex > 0) {
        this.currentIndex--
      }
    },

    dismissCurrentAlert() {
      const current = this.filteredAlerts[this.currentIndex]

      this.alerts = this.alerts.filter(alert => alert !== current)

      if (this.currentIndex >= this.filteredAlerts.length && this.currentIndex > 0) {
        this.currentIndex--
      }
    }
  }
}
</script>
<style scoped>
.alerts-wrapper {
  position: relative;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99999;
}

.alert-banner {
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(6px);
}


.alert-warning {
  background-color: #fff3cd;
  color: #856404;
}

.alert-primary {
  background-color: #cfe2ff;
  color: #084298;
}

.alert-danger {
  background-color: #f8d7da;
  color: #842029;
}

.alert-info {
  background-color: #d1ecf1;
  color: #055160;
}

.alert-content-wrapper {
  max-width: 1200px;
  width: 100%;
  padding: 0 20px;
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  gap: 12px;
}

.alert-icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.alert-text {
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.alert-title {
  font-weight: 600;
  font-size: 14px;
}

.alert-subtitle {
  font-size: 14px;
}

.alert-link {
  font-weight: 500;
  text-decoration: underline;
  color: inherit;
  font-size: 14px;
  margin-left: 4px;
}

.alert-link:hover {
  opacity: 0.8;
}

.alert-navigation {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
  flex-shrink: 0;
}

.nav-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.nav-btn:hover:not(:disabled) {
  opacity: 1;
}

.nav-btn:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

.alert-counter {
  font-size: 13px;
  white-space: nowrap;
}

.alert-close {
  background: none;
  border: none;
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
  padding: 0 0 0 12px;
  opacity: 0.6;
  transition: opacity 0.2s;
  flex-shrink: 0;
}

.alert-close:hover {
  opacity: 1;
}

@media (max-width: 768px) {
  .alert-content-wrapper {
    padding: 0 16px;
    gap: 8px;
  }
  
  .alert-text {
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
  }
  
  .alert-title,
  .alert-subtitle {
    font-size: 13px;
  }
  
  .alert-link {
    font-size: 13px;
    margin-left: 0;
  }
  
  .alert-navigation {
    display: none;
  }
}
</style>
